"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetaTypeGroupSchema = void 0;
exports.MetaTypeGroupSchema = {
    "$id": "https://www.redbull.com/schemas/type-groups/meta.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "MetaTypeGroup",
    "description": "MetaTypeGroup represents one of the following types: FeaturingBundle, ContentTypeSchema, GenericTypeSchema, JsonApiTypeSchema, VideoMarkerTypeSchema",
    "oneOf": [
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/featuring-bundles.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/types/content.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/types/generic.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/types/jsonapi-resource.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/types/video-marker.schema.json"
        }
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWV0YS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbW9kdWxlcy90eXBlLWdyb3Vwcy9tZXRhLnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLG1CQUFtQixHQUFHO0lBQ2pDLEtBQUssRUFBRSw4REFBOEQ7SUFDckUsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUsZUFBZTtJQUN4QixhQUFhLEVBQUUsc0pBQXNKO0lBQ3JLLE9BQU8sRUFBRTtRQUNQO1lBQ0UsTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFLCtEQUErRDtTQUN4RTtRQUNEO1lBQ0UsTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFLDJEQUEyRDtTQUNwRTtRQUNEO1lBQ0UsTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFLDJEQUEyRDtTQUNwRTtRQUNEO1lBQ0UsTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFLG9FQUFvRTtTQUM3RTtRQUNEO1lBQ0UsTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFLGdFQUFnRTtTQUN6RTtLQUNGO0NBQ0YsQ0FBQSJ9